document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('[data-typewriter]');

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        el.style.transition = 'opacity 1s ease-in-out';
        el.style.opacity = 1; // Nastaví průhlednost na 100%
        observer.unobserve(el);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  elements.forEach(el => {
    el.style.opacity = 0; // Počáteční průhlednost 0%
    observer.observe(el);
  });
});